import {
    AcceptOrganizationInvite,
    CreateOrganizationInvite,
    OrganizationInvite,
    OrganizationInviteListResponse,
    OrganizationInviteQueryParams,
    UpdateOrganizationInvite
} from '@frontend/account/types';
import { APIClient, ApiQueryParams } from '@frontend/api-utils';

export class OrganizationInviteClient extends APIClient {
    public static readonly endpoint = '/account-api/v1';

    public static async fetchInvites(queryParams?: ApiQueryParams<OrganizationInviteQueryParams>): Promise<OrganizationInviteListResponse> {
        return await this.apiPaginated<OrganizationInviteListResponse, OrganizationInviteQueryParams>(`${this.endpoint}/invites`, queryParams);
    }

    public static async resolveInvites(ids: string[], field: string = 'id'): Promise<OrganizationInviteListResponse> {
        return this.resolve<OrganizationInviteListResponse>(`${this.endpoint}/invites`, ids, field);
    }

    public static async deleteInvites(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/invites-delete`, { ids });
        return await this.handleVoidResponse(response);
    }

    public static async postInvite(accountId: string, invite: CreateOrganizationInvite): Promise<OrganizationInvite> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/invites`, invite);
        return await this.handleResponse<OrganizationInvite>(response);
    }

    public static async fetchInvite(accountId: string, inviteId: string): Promise<OrganizationInvite> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`);
        return await this.handleResponse<OrganizationInvite>(response);
    }

    public static async patchInvite(accountId: string, inviteId: string, invite: Partial<UpdateOrganizationInvite>): Promise<OrganizationInvite> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`, invite);
        return await this.handleResponse<OrganizationInvite>(response);
    }

    public static async deleteInvite(accountId: string, inviteId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/invites/${inviteId}`);
        return await this.handleVoidResponse(response);
    }

    public static async acceptOrganizationInvite(body: AcceptOrganizationInvite, includeAccessToken = true): Promise<void> {
        const response = await this.post(`${this.endpoint}/accept-invite`, body, includeAccessToken);
        return await this.handleVoidResponse(response);
    }
}
